import * as React from "react";
import {API_URL} from '../../../settings/local_settings';
import {AuthUrlLinkBase} from "./AuthUrlLinkBase";
import {TiendaNubeConnectButton} from "./TiendaNubeConnectButton";
import { withTranslation } from 'react-i18next';
import {APIClient} from "../../../utils/APIClient";

export class TiendaNubeLinkComponentClass extends AuthUrlLinkBase {

    constructor(props) {
        super(props);
        this.state = {
            hasConnection: props.hasConnection,
            disabled: props.disabled,
            loading: false
        };

        this.handleConnectClick = this.handleConnectClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.disabled !== this.props.disabled) {
            this.setState({ disabled: this.props.disabled });
        }
    }

    async _getAuthURL(){
        const url = API_URL + 'get_auth_url/tienda_nube/';
        const response = await new APIClient(url).call('GET');
        
        if (response.status === 'ERROR') {
            const errorMessage = response.errors?.[0]?.message || response.error_message || 'Error al obtener URL de autorización';
            throw new Error(errorMessage);
        }
        
        return response.auth_url;
    }

    _getDeleteUrl(){
        return API_URL + 'agency/tienda-nube-connection/delete/';
    }

    renderConnectionButton() {
        return <TiendaNubeConnectButton onClick={this.handleConnectClick} disabled={this.state.disabled || this.state.loading} />;
    }

    renderDisconnectButton() {
        const { t } = this.props;
        return <button className="btn" onClick={this.deleteAgencyConnection}>{t('tienda_nube_link.disconnect_from_tienda_nube')}</button>
    }

    async redirectToAuthPage() {
        this.setState({ loading: true });
        
        try {
            const authUrl = await this._getAuthURL();
            window.location.href = authUrl;
        } catch (error) {
            this.setState({ loading: false });
            const { t } = this.props;
            alert(t('tienda_nube_link.error_getting_auth_url') || error.message);
        }
    }

    handleConnectClick() {
        if (!this.state.disabled && !this.state.loading) {
            this.redirectToAuthPage();
        }
    }
}

export const TiendaNubeLinkComponent = withTranslation()(TiendaNubeLinkComponentClass);
export default TiendaNubeLinkComponent;

